<script>
    import { createEventDispatcher } from 'svelte'
    import { Row, Col, Button } from 'sveltestrap'
    import Icon from 'svelte-awesome'
    import { plus } from 'svelte-awesome/icons'
    import FormAlerts from '../FormAlerts.svelte'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import VenueInfo from './VenueInfo.svelte'
    import { currentSchool } from '@fno/service/api/schools.js'

    export let context
    export let saving
    export let schoolId

    let rewardsEnabled = context.view.rewardsEnabled || false

    const latLongDemoUrl = "https://app.teamwalnut.com/player/?demoId=b8a7ea2e-c29f-4d20-916b-04c6f0be2b91&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app"
    const { tier } = $currentSchool

    const dispatch = createEventDispatcher()
    const addVenue = () => {
        context.form.arenas = [
            ...context.form.arenas,
            {
                $create: true,
                id: context.form.arenas.length,
                attributes: {
                    geofenceRadius: 150,
                    latitude: '',
                    longitude: '',
                    $isRewardable: rewardsEnabled,
                    arenaIcon: {
                        url: '',
                    },
                    name: '',
                    $attributesToPreserve: [ 'latitude', 'longitude' ]
                },
                meta: {
                    schoolId,
                    state: 'published'
                }
            }
        ]
    }
</script>

<h1>Venues</h1>

<p>
    Please add each venue that your sports team considers their home venue.
    If a team has multiple home venues, create the venue that is utilized the most.
    The icon for your venues will be displayed on the map feature of the app.
    NOTE: A venue is required for any teams added on the next page.
</p>

<p>
    For help finding the Latitude & Longitude of your venues, follow the
    <a href={latLongDemoUrl} target="_blank" rel="noreferrer">
        TAB: Finding Your Venue Coordinates demo
    </a>.
</p>

{#each context.form.arenas as arena, index (arena.id)}
    <Row class="mb-3">
        <Col>
            <VenueInfo bind:context formKey="arenas" {index} {rewardsEnabled} {tier} on:change />
        </Col>
    </Row>
{/each}

<Row>
    <Col />
</Row>

<Row>
    <Col>
        <p>
            <Button on:click={addVenue}>
                Add another venue
                <Icon data={plus} />
            </Button>
        </p>
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons
    {context}
    {saving}
    on:save
    on:nextStepClicked={() => dispatch('nextStepClicked', { context, tier })}
    on:previousStepClicked
/>
